import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const mediaUrl = (src) => {
  if (!src) return src;
  return src.startsWith("http") ? src : `${BACKEND_URL}${src}`;
};

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("brsk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  // public
  login: (data) => client.post("/auth/login", data),
  me: () => client.get("/auth/me"),
  createEnquiry: (data) => client.post("/enquiries", data),
  createAdmission: (data) => client.post("/admissions", data),
  createComplaint: (data) => client.post("/complaints", data),
  createContact: (data) => client.post("/contact", data),
  getNotices: () => client.get("/notices"),
  getEvents: () => client.get("/events"),
  getGallery: () => client.get("/gallery"),
  getDownloads: () => client.get("/downloads"),
  getStudentResources: () => client.get("/student-resources"),
  getFeePackages: () => client.get("/fee-packages"),
  checkout: (data) => client.post("/payments/checkout", data),
  paymentStatus: (sid) => client.get(`/payments/status/${sid}`),
  // admin
  stats: () => client.get("/admin/stats"),
  listEnquiries: () => client.get("/admin/enquiries"),
  listAdmissions: () => client.get("/admin/admissions"),
  listComplaints: () => client.get("/admin/complaints"),
  listContacts: () => client.get("/admin/contacts"),
  listPayments: () => client.get("/admin/payments"),
  addNotice: (d) => client.post("/admin/notices", d),
  delNotice: (id) => client.delete(`/admin/notices/${id}`),
  addEvent: (d) => client.post("/admin/events", d),
  delEvent: (id) => client.delete(`/admin/events/${id}`),
  addGallery: (d) => client.post("/admin/gallery", d),
  uploadGallery: (formData) => client.post("/admin/gallery/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }),
  delGallery: (id) => client.delete(`/admin/gallery/${id}`),
  addDownload: (d) => client.post("/admin/downloads", d),
  delDownload: (id) => client.delete(`/admin/downloads/${id}`),
  addResource: (d) => client.post("/admin/student-resources", d),
  delResource: (id) => client.delete(`/admin/student-resources/${id}`),
};

export default client;
